import { emptyArray } from 'ui-components/default-props/empty';
import { baseReducer } from '../core/base-reducer';

import type { SellerRecommendation } from './api/seller-recommendation';
import { APP_INITIALIZATION } from '../core/base-actions';
import * as Actions from './seller-recommendations.actions';
import { namespace as sellerRecommendationsNamespace } from './seller-recommendations.reducer.metadata';

export type SellerRecommendationsState = {
  recommendations: readonly SellerRecommendation[];
  isLoading: boolean;
  hasLoaded: boolean;
};

const initialState: SellerRecommendationsState = {
  recommendations: emptyArray,
  isLoading: false,
  hasLoaded: false,
};

const actionHandlerMap = {
  [APP_INITIALIZATION]: (state: SellerRecommendationsState) => ({
    ...state,
    isLoading: true,
  }),
  [Actions.GET_SELLER_RECOMMENDATIONS]: (state: SellerRecommendationsState) => ({
    ...state,
    isLoading: true,
  }),
  [Actions.GET_SELLER_RECOMMENDATIONS_SUCCESS]: (
    state: SellerRecommendationsState,
    { recommendations }: GetSellerRecommendationsSuccessAction,
  ) => ({
    ...state,
    recommendations,
    isLoading: false,
    hasLoaded: true,
  }),
};

type GetSellerRecommendationsSuccessAction = { recommendations: SellerRecommendation[] };

export const sellerRecommendationsReducer = baseReducer(initialState, actionHandlerMap);
export const namespace = sellerRecommendationsNamespace;
